<template>
  <div class="content">
    <div style="height: 70px;">
      <HomeHeader :forOrder="true"></HomeHeader>
    </div>
    <div class="order_datail_box">
      <div></div>
      <div>
        <p style="font-size: 20px;margin: 30px 0;">
          <span style="color:#1e50f0">{{ $t('header.order_center') }}</span>/ {{ $t('center.order_detail') }}
          ({{ orderDetailData.outerOrderId }})
        </p>
        <div class="order_box_new">
          <div class="main_box">
            <div class="order_status_box basic_box">
              <div style="display: flex;justify-content: space-between">
                <span style="font-size: 16px;font-weight: 600">订单状态</span>
                <div v-if="orderDetailData.orderStatus">
                  <div style="padding: 4px 8px;border-radius: 50px"
                       :style="{backgroundColor: getStatusItem(orderDetailData.orderStatus).bgColor}">
                    <i :class="getStatusItem(orderDetailData.orderStatus).icon"
                       style="font-size: 12px" :style="{color: getStatusItem(orderDetailData.orderStatus).color}"/>
                    <span :style="{color: getStatusItem(orderDetailData.orderStatus).color}">
                    {{ getStatusName(orderDetailData.orderStatus) }}
                  </span>
                  </div>
                </div>
              </div>
              <div style="font-weight: 600;font-size: 14px;margin-top: 15px">
                <span>订单号: {{ orderDetailData.channelOrderNum }}</span>
                <i class="iconfont icon-a-qietu23" style="cursor: pointer;font-weight: normal"
                   @click="changeChlOrderNum" v-show="orderDetailData.extensions && !orderDetailData.extensions.includes('uptChlOrderNum')"></i>
              </div>
              <div style="margin-top: 15px">
                <el-button style="background-color: #f3f4f6;border: none" size="medium"
                           @click="showAddWorkOrderDialog = true">
                  提交工单
                </el-button>
                <el-button style="background-color: #f3f4f6;border: none" size="medium" @click="cancelOrder"
                           v-if="canCancelTime(orderDetailData.formatCancelPolicy) || canCancelStatus()">
                  取消
                </el-button>
                <el-button size="medium" @click="toHotelDetail()" v-if="orderDetailData.hotelId"
                           type="primary">
                  再次预订
                </el-button>
                <el-button type="primary" size="medium" @click="toHotelConfirmOrder" v-if="isShowConfigOrderBtn">
                  获取确认函
                </el-button>
              </div>
            </div>
            <div class="order_basic_box basic_box">
              <div style="font-size: 16px;font-weight: 600;margin-bottom: 24px">订单基本信息</div>
              <div class="room_info" style="border-bottom: 1px solid #f7f8f9">
                <div class="info_item">
                  <div class="title">房型:</div>
                  <div class="info">
                    <span>{{ orderDetailData.roomTypeName }}</span>
                    <span class="a_text" @click="showRoomDetail" v-if="orderDetailData.hotelId && orderDetailData.orderId">查看详情</span>
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">房间数:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu24"/>
                    {{ orderDetailData.roomCount }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">早餐:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu25"/>
                    {{ orderDetailData.breakfastDesc }}
                  </div>
                </div>
                <div class="info_item" v-if="orderDetailData.hotelConfirmationNumber">
                  <div class="title">酒店确认号:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu26"/>
                    {{ orderDetailData.hotelConfirmationNumber }}
                  </div>
                </div>
              </div>
              <div class="check_info" style="margin-top: 16px">
                <div class="info_item">
                  <div class="title">入住日期:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu27"/>
                    {{ orderDetailData.checkIn }}至{{ orderDetailData.checkOut }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">入住人:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu28"/>
                    {{ $commonUtil.formatGuestName(orderDetailData.guestName) }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">联系人:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu28"/>
                    {{ orderDetailData.contactName }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">联系电话:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu30"/>
                    {{ orderDetailData.contactPhone }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">邮箱:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu32"/>
                    {{ orderDetailData.contactEmail }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">支付方式:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu33"/>
                    {{ paymentMap[orderDetailData.paymentType] ? paymentMap[orderDetailData.paymentType] : '/' }}
                  </div>
                </div>
                <div class="info_item">
                  <div class="title">预订时间:</div>
                  <div class="info">
                    <i class="iconfont icon-a-qietu29"/>
                    {{ orderDetailData.orderTime ? orderDetailData.orderTime.replace('T', ' ') : '/' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="basic_box">
              <div style="font-size: 16px;font-weight: 600">注意事项</div>
              <div class="notice_item">
                <div class="notice_title">
                  <i class="el-icon-info" style="color: #0066cc;font-weight: normal"/>
                  <span>预订提示</span>
                </div>
                <span style="line-height: 20px;">{{ $t('booking.info_confirm') }}</span>
              </div>
              <div class="notice_item">
                <div class="notice_title">
                  <i class="iconfont icon-a-qietu40" style="color: #0066cc;font-weight: normal"/>
                  <span>更改或取消</span>
                </div>
                <span style="line-height: 20px;">{{ $t('booking.change_info') }}</span>
              </div>
              <div class="notice_item">
                <div class="notice_title">
                  <i class="iconfont icon-a-qietu41" style="color: #0066cc;font-weight: normal"/>
                  <span>未到店或晚退</span>
                </div>
                <span style="line-height: 20px;">{{ $t('booking.late_info') }}</span>
              </div>
            </div>
            <div class="work_order_content" style="margin-top: 16px;" v-if="workOrderList.length">
              <div class="box_title" style="display: flex;justify-content: space-between;">
                <span style="font-family: '苹方';">工单信息</span>
                <span @click="showAddWorkOrderDialog = true"
                      style="color: #1e50f0;cursor: pointer;font-family: '苹方';user-select: none;">创建新工单</span>
              </div>
              <div class="item_box">
                <div class="work_order_item" v-for="item in workOrderList" :key="item.workOrderItem.workOrderId"
                     :ref="item.workOrderItem.workOrderId">
                  <div class="item_header">
                    <div>
                      <img src="../../../assets/newImage/work_order_icon.png">
                    </div>
                    <div style="font-weight: 600;font-size: 14px;">
                      工单类型：
                      {{ getWorkOrderTypeName(item.workOrderItem.subTypeId, true) }}
                    </div>
                    <div>工单号：{{ item.workOrderItem.workOrderId }}</div>
                    <div>是否到店：{{ getWorkOrderTypeName(item.workOrderItem.typeId) }}</div>
                    <div style="margin-left: auto;">
                  <span class="status" :style="'background-color:' + getStatusColor(item.workOrderItem.status) + ';'">
                    {{ getWorkOrderStatusName(item.workOrderItem.status) }}
                  </span>
                    </div>
                    <el-popconfirm title="当前工单只能催单一次，确定催单吗？" @onConfirm="urgeWorkOrder(item)"
                                   v-if="item.workOrderItem.showUrgeBtn">
                      <el-button slot="reference" type="text" style="color: #1e50f0;font-size: 13px;">催单</el-button>
                    </el-popconfirm>
                    <div>
                      <img src="../../../assets/newImage/expand.png" style="cursor: pointer;"
                           v-if="!expandMap[item.workOrderItem.workOrderId]"
                           @click="expandMap[item.workOrderItem.workOrderId] = !expandMap[item.workOrderItem.workOrderId]">
                      <img src="../../../assets/newImage/contract.png" style="cursor: pointer;" v-else
                           @click="expandMap[item.workOrderItem.workOrderId] = !expandMap[item.workOrderItem.workOrderId]">
                    </div>
                  </div>
                  <div class="item_content" :class="expandMap[item.workOrderItem.workOrderId] ? 'open' : 'close'">
                    <p class="item_content_title">处理过程</p>
                    <div class="detail" :ref="'d' + item.workOrderItem.workOrderId">
                      <div style="padding-top: 5px;">
                    <span class="status" :style="'background-color:' + getStatusColor(item.workOrderItem.status) + ';'">
                      {{ getWorkOrderStatusName(item.workOrderItem.status) }}
                    </span>
                      </div>
                      <div style="width: 50%;">
                        <el-timeline reverse>
                          <el-timeline-item v-for="i in item.details" :key="i.id"
                                            :timestamp="getOperator(i) + i.handleTime.replace('T', ' ')" placement="top"
                                            :color="i.operatorType == 1 ? '#5dcfff' : '#e6a23c'">
                            <div class="msg_deatil">
                              <div v-html="i.handleContent ? i.handleContent.replace(/\n/g, '<br/>') : ''"></div>
                              <div v-if="i.attachment" style="display: flex;flex-wrap: wrap;column-gap: 8px;">
                                <el-image v-for="(item, index) in getImags(i.attachment)" :key="index"
                                          style="width: 100px; height: 100px;cursor: pointer;border: 1px solid #e8ebef;border-radius: 4px;margin-bottom: 8px;"
                                          :src="item" @click="showImg(item)">
                                </el-image>
                              </div>
                            </div>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                    <div class="reply_box" v-if="item.workOrderItem.status != 2">
                      <el-upload style="margin-bottom: 10px;" :disabled="item.workOrderItem.status == 2"
                                 class="upload-demo"
                                 action="#" :limit="9" :on-exceed="handleExceed"
                                 :file-list="msgList[item.workOrderItem.workOrderId].fileList" :auto-upload="false"
                                 :on-change="(file, fileList) => onFileChange(file, fileList, item.workOrderItem.workOrderId)"
                                 :on-remove="(file, fileList) => onFileRemove(file, fileList, item.workOrderItem.workOrderId)"
                                 accept="image/bmp,image/jpg,image/png">
                        <div>
                          <el-icon class="el-icon-picture" style="font-size: 20px;cursor: pointer;color: #d7d7d7"
                                   :style="item.workOrderItem.status == 2 ? 'cursor: not-allowed;' : ''"
                                   title="上传图片"></el-icon>
                        </div>
                      </el-upload>
                      <el-input v-model="msgList[item.workOrderItem.workOrderId].msg" type="textarea" :rows="4"
                                placeholder="按Enter快捷键发送，Ctrl+Enter换行" :maxlength="500" show-word-limit
                                resize="none"
                                :disabled="item.workOrderItem.status == 2"
                                @keyup.enter.native="e => sendMsg(item.workOrderItem.workOrderId, e)">
                      </el-input>
                      <el-button @click="e => sendMsg(item.workOrderItem.workOrderId, e)" class="send_btn" size="mini"
                                 :disabled="item.workOrderItem.status == 2" type="primary">发送
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right_box">
            <div class="hotel_info_box_new basic_box">
              <div style="font-size: 16px;font-weight: 600" @click="toHotelDetail()">酒店信息</div>
              <div class="hotel_img" @click="toHotelDetail()">
                <img :src="hotelInfo.mainImage ? hotelInfo.mainImage : '../../../assets/newImage/noSwiperImg.png'"
                     alt=""/>
              </div>
              <div class="hotel_name">
                <i class="iconfont icon-a-qietu34" style="color: #374151"/>
                <div>
                  <span style="font-size: 14px;font-weight: bolder">{{ getHotelName(1) }}</span>
                  <span style="font-size: 12px"
                        v-if="getHotelName(2) && getHotelName(1) !== getHotelName(2)">
                    ({{ getHotelName(2) }})
                  </span>
                </div>
              </div>
              <div class="hotel_name" style="font-size: 14px">
                <div style="margin-right: 58px;">
                  <i class="iconfont icon-a-qietu35" style="color: #374151"/>
                  <span>{{ hotelInfo.country }}</span>
                </div>
                <div>
                  <i class="iconfont icon-a-qietu34" style="color: #374151"/>
                  <span>{{ hotelInfo.city }}</span>
                </div>
              </div>
              <div class="hotel_name">
                <i class="iconfont icon-a-qietu30" style="color: #374151"/>
                <div>{{ hotelInfo.phone ? hotelInfo.phone : hotelInfo.hotelPhone }}</div>
              </div>
              <div class="hotel_name">
                <i class="iconfont icon-dizhi" style="color: #374151"/>
                <div>
                  <span>{{ hotelInfo.addressCn }}</span>
                  <span style="font-size: 12px" v-if="hotelInfo.address">({{ hotelInfo.address }})</span>
                </div>
              </div>
            </div>
            <div class="basic_box">
              <div style="font-size: 16px;font-weight: 600">取消政策</div>
              <div v-if="orderDetailData.formatCancelPolicy"
                   style="font-size: 16px;font-weight: bolder;color: #00d532;margin-top: 15px;">
                <i class="el-icon-success"/>
                <span>{{ orderDetailData.formatCancelPolicy }}前可取消</span>
              </div>
              <div v-else style="font-size: 16px;font-weight: bolder;color: red;margin-top: 15px;">
                <i class="el-icon-error"/>
                <span>不可取消</span>
              </div>
            </div>
            <div class="price_box basic_box" style="margin-top: 16px" v-if="Object.keys(dailyPriceMap).length">
              <div style="font-size: 16px;font-weight: 600;margin-bottom: 24px">每日价格</div>
              <div v-for="(value, key, index) of dailyPriceMap" :key="index">
                <div class="price_info">
                  <div class="date">{{ key }}</div>
                  <div class="price">{{ value / 100 }} <span style="font-size: 12px">×</span>
                    {{ orderDetailData.roomCount }}
                  </div>
                </div>
              </div>
              <div class="total_box">
                <div style="font-weight: 600">总计</div>
                <div class="price">￥{{ $commonUtil.formatPrice(orderDetailData.payAmount) }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="order_info_box">-->
        <!--          <div class="order_info_item order_num">-->
        <!--            <span style="font-family: '苹方'">{{ orderDetailData.outerOrderId }}</span>-->
        <!--            <span style="font-family: '苹方'">-->
        <!--              {{ $t('hotel_detail.total') }}-->
        <!--              <span style="color: #1e50f0;">-->
        <!--                CNY {{$commonUtil.formatPrice(orderDetailData.payAmount) }}-->
        <!--              </span>-->
        <!--            </span>-->
        <!--          </div>-->
        <!--          <div class="order_info_item">{{ $t('center.room_type') }}：{{ orderDetailData.roomTypeName }}</div>-->
        <!--          <div class="order_info_item">{{ $t('center.Reservation_time') }}：{{ orderDetailData.orderTime }}</div>-->
        <!--          <div class="order_info_item">-->
        <!--            {{ $t('search.checkIn') }}：{{ orderDetailData.checkIn }} {{ $t('booking.to') }}-->
        <!--            {{orderDetailData.checkOut }}-->
        <!--          </div>-->
        <!--          <div class="order_info_item">{{ $t('search.room') }}：{{ orderDetailData.roomCount }}</div>-->
        <!--          <div class="order_info_item">-->
        <!--            {{ $t('booking.guest') }}：{{$commonUtil.formatGuestName(orderDetailData.guestName) }}-->
        <!--          </div>-->
        <!--          <div class="order_info_item">{{ $t('hotel_detail.breakfast') }}：{{ orderDetailData.breakfastDesc }}</div>-->
        <!--          <div class="order_info_item">{{ $t('center.contact_text') }}：{{ orderDetailData.contactName }}</div>-->
        <!--          <div class="order_info_item">{{ $t('center.contact_number') }}：{{ orderDetailData.contactPhone }}</div>-->
        <!--          <div class="order_info_item">{{ $t('booking.email') }}：{{ orderDetailData.contactEmail }}</div>-->
        <!--          &lt;!&ndash; <div class="order_info_item"></div> &ndash;&gt;-->
        <!--          <div class="order_info_item">{{ $t('center.Payment_method') }}：-->
        <!--            <span-->
        <!--              v-html="paymentMap[orderDetailData.paymentType] ? paymentMap[orderDetailData.paymentType] : '/'"></span>-->
        <!--          </div>-->
        <!--          <div class="order_info_item" :style="isShowConfigOrderBtn ? '' : 'grid-column-start: 2;grid-column-end: 4;'">-->
        <!--            {{ $t('center.confirmation_number') }}：-->
        <!--            {{ orderDetailData.hotelConfirmationNumber ? orderDetailData.hotelConfirmationNumber : '/' }}-->
        <!--          </div>-->
        <!--          <div class="order_info_item" :class="hotelInfo.customer ? '' : 'order_status'">-->
        <!--            {{ $t('center.Order_status') }}：-->
        <!--            <span style="color: #00d532">{{getStatusName(orderDetailData.orderStatus) }}</span>-->
        <!--          </div>-->
        <!--          <div class="order_info_item" :style="isShowConfigOrderBtn ? '' : 'grid-column-start: 2;grid-column-end: 4;'" v-if="hotelInfo.customer">-->
        <!--            特殊备注：-->
        <!--            {{ hotelInfo.customer }}-->
        <!--          </div>-->
        <!--          <div class="order_info_item img_box" v-if="imgs && imgs.length">-->
        <!--            <span>图片：</span>-->
        <!--            <div class="img__content">-->
        <!--              <el-image v-for="(img, index) in imgs" :key="index" @click="showImg(img)"-->
        <!--                style="width: 80px; height: 80px;cursor: pointer" :src="img" fit="cover"></el-image>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="confirm_btn_box" v-if="isShowConfigOrderBtn">-->
        <!--            <b2b-button @click="toHotelConfirmOrder"-->
        <!--                        style="width: 40%;border-radius: 50px;height: 35px;line-height: 35px;font-size: 14px">-->
        <!--              获取酒店确认单-->
        <!--            </b2b-button>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="price_info" v-if="dailyPrice.length">-->
        <!--          <div class="price_title">-->
        <!--            <span style="font-family: '苹方'">每日价格</span>-->
        <!--          </div>-->
        <!--          <div class="content" v-for="(item, index) in dailyPrice" :key="index">-->
        <!--            <div class="item_content" v-for="(i, ind) in item" :key="ind">-->
        <!--              <div class="info_item">{{ i.date }}</div>-->
        <!--              <div class="info_item">￥{{ i.value / 100 }} * {{ orderDetailData.roomCount }}</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="hotel_info_box">-->
        <!--          <div class="order_info_item order_num">-->
        <!--            <span style="font-family: '苹方'">{{ orderDetailData.hotelName }}</span>-->
        <!--            <span style="font-family: '苹方';cursor: pointer;color: #1e50f0" @click="toHotelDetail()" v-if="orderDetailData.hotelId">-->
        <!--              查看详情-->
        <!--            </span>-->
        <!--          </div>-->
        <!--          <div class="order_info_item">{{ $t('center.Country_name') }}：{{ hotelInfo.country }}</div>-->
        <!--          <div class="order_info_item">{{ $t('center.Hotel_City') }}：{{ hotelInfo.city }}</div>-->
        <!--          <div class="order_info_item">{{ $t('center.Hotel_telephone') }}：{{ hotelInfo.phone ? hotelInfo.phone : hotelInfo.hotelPhone }}</div>-->
        <!--          <div class="order_info_item order_status">-->
        <!--            {{ $t('center.hotels_address') }}：{{ hotelInfo.addressCn }}-->
        <!--            {{hotelInfo.address ? "(" + hotelInfo.address + ")" : "" }}-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="hotel_info_box">-->
        <!--          <div class="order_info_item order_num">-->
        <!--            <span style="font-family: '苹方'">{{ $t('hotel_detail.Cancel_the_policy') }}</span>-->
        <!--          </div>-->
        <!--          <div class="order_info_item order_status">-->
        <!--            <div v-if="orderDetailData.formatCancelPolicy" style="color:#00d532;">-->
        <!--              {{ $t('center.Latest_cancellation_time') }}：{{ orderDetailData.formatCancelPolicy }}-->
        <!--              <el-button type="primary" size="mini" style="margin-left: 20px;" @click="cancelOrder"-->
        <!--                :disabled="!canCancelTime(orderDetailData.formatCancelPolicy) || !canCancelStatus()">-->
        <!--                {{ $t('header.cancel') }}-->
        <!--              </el-button>-->
        <!--            </div>-->
        <!--            <div v-else style="color: red;">{{ $t('hotel_detail.no_cancel') }}</div>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="attention_item_box">-->
        <!--          <div style="border: 1px solid #e8ebef;">-->
        <!--            <div class="box_title">-->
        <!--              {{ $t('booking.attentions') }}-->
        <!--            </div>-->
        <!--            <div style="padding: 10px" class="attention_item">-->
        <!--              <div class="attention_item_title">{{ $t('booking.Booking_prompt') }}</div>-->
        <!--              <div>{{ $t('booking.info_confirm') }}</div>-->
        <!--              <div class="attention_item_title">{{ $t('booking.Change_or_cancel') }}</div>-->
        <!--              <div>{{ $t('booking.change_info') }}</div>-->
        <!--              <div class="attention_item_title">{{ $t('booking.Not_arriving_or_late') }}</div>-->
        <!--              <div>{{ $t('booking.late_info') }}</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div></div>
    </div>
    <el-dialog title="提交工单" :visible.sync="showAddWorkOrderDialog" width="750px" :lock-scroll="false">
      <AddWorkOrder :orderInfo="orderDetailData" :showAddWorkOrderDialog="showAddWorkOrderDialog"
                    @closeDialog="closeDialog"/>
    </el-dialog>
    <clause-dialog :isShow="isShowClause" @closeDialog="isShowClause = false"></clause-dialog>
    <el-image-viewer :url-list="selImg" v-if="showBigImg" :onClose="onClose"></el-image-viewer>
    <el-dialog title="修改订单号" :visible.sync="showChangeChlOrderNumDialog" width="450px" custom-class="order_dialog">
      <div>
        <p style="margin-bottom: 15px;">贵司订单号</p>
        <el-input v-model="newChlOrderNum" placement="请输入" clearable></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChange" :loading="changeBtnLoading">确 定</el-button>
      </span>
    </el-dialog>
    <div class="room_detail">
      <HotelImg ref="hotelImgRef"/>
    </div>
    <div style="background-color: #fff;margin-top: 70px;">
      <ContantUs/>
      <footerInfo/>
    </div>
  </div>
</template>

<script>

import HomeHeader from '../booking/components/HomeHeader.vue'
import ContantUs from '../booking/components/ContantUs.vue'
import ClauseDialog from '../../frame/components/ClauseDialog.vue'
import footerInfo from '../frame/footerInfo.vue'
import AddWorkOrder from './components/AddWorkOrder.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {sendWebSocket, removeHandler} from '../../../assets/js/webSocket.js'
import HotelImg from '../booking/components/HotelImg.vue'

export default {
  name: 'OrderDetail',
  data () {
    return {
      orderDetailData: {},
      hotelInfo: {},
      isShowClause: false,
      orderStatusManualConfirmed: 14,
      orderStatusConfirm: 2,
      confirmStatusList: [2, 13, 14],
      orderStatusOptions: [
        {id: 0, name: this.$t('center.all'), value: -1, color: '#ffffff'},
        {
          id: 1,
          name: this.$t('center.Processing'),
          value: [0, 1, 4, 5, 11],
          color: '#ffffff',
          icon: 'iconfont icon-chulizhong',
          bgColor: '#f5a623'
        },
        {
          id: 2,
          name: this.$t('center.Confirmed'),
          value: [2, 13, 14],
          color: '#166534',
          icon: 'el-icon-circle-check',
          bgColor: '#dcfce7'
        },
        {
          id: 3,
          name: this.$t('center.Canceled'),
          value: [3, 15],
          color: '#b6b4b4',
          icon: 'iconfont icon-yiquxiao',
          bgColor: '#f3f1f1'
        },
        {
          id: 4,
          name: this.$t('center.Full_house'),
          value: [12],
          color: '#fa1f1f',
          icon: 'iconfont icon-manfang',
          bgColor: '#faa2a2'
        },
        {
          id: 5,
          name: this.$t('center.Order_Close'),
          value: [16],
          color: '#b6b4b4',
          icon: 'el-icon-circle-close',
          bgColor: '#f3f1f1'
        }
      ],
      paymentMap: {
        1: '额度支付',
        2: '支付宝支付',
        3: '微信支付'
      },
      partnerInfo: {},
      showAddWorkOrderDialog: false,
      workOrderList: [],
      workOrderTypes: [],
      msgList: {},
      selImg: [],
      showBigImg: false,
      expandMap: {},
      imgs: [],
      dailyPrice: [],
      dailyPriceMap: {},
      orderStatusInterval: null,
      showChangeChlOrderNumDialog: false,
      newChlOrderNum: '',
      changeBtnLoading: false
    }
  },
  components: {
    ClauseDialog,
    HomeHeader,
    ContantUs,
    footerInfo,
    AddWorkOrder,
    ElImageViewer,
    HotelImg
  },
  computed: {
    isShowConfigOrderBtn () {
      return [2, 13, 14].includes(this.orderDetailData.orderStatus)
    }
  },
  async mounted () {
    if (this.$route.query.params) {
      let info = window.atob(this.$route.query.params)
      let orderInfo = JSON.parse(decodeURIComponent(info))
      await this.setOrderStatus(orderInfo.outerOrderId)
    } else {
      await this.$router.push('/NewHome/HomeSearch')
      return
    }
    this.partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
    if (this.orderDetailData.hotelId) {
      await this.onSearch()
    } else {
      this.hotelInfo = JSON.parse(this.orderDetailData.extensions)
    }
    await this.searchWorkOrders(true)
    await this.searchOrderItem()
    this.$commonUtil.modfiyicon()
    sendWebSocket(true, this.handleMessage, 'workOrder')
    if (this.orderDetailData && this.orderDetailData.orderClassification === 1) {
      await this.searchExternalOrderImages()
    }
    if (this.orderDetailData.orderStatus !== 3 && this.orderDetailData.orderStatus !== 15) {
      this.getOrderStatus()
    }
  },
  created () {
    this.getWorkOrderTypes()
  },
  activated () {
    this.$emit('updateWidth', 1650)
  },
  beforeDestroy () {
    this.closeInterval()
  },
  methods: {
    getOrderStatus () {
      this.orderStatusInterval = setInterval(async () => {
        await this.setOrderStatus()
      }, 15000)
    },
    closeInterval () {
      clearInterval(this.orderStatusInterval)
    },
    async setOrderStatus (outerId) {
      let partnerInfo = JSON.parse(this.$common.isLogin())
      let headers = {accessToken: partnerInfo ? partnerInfo.token : ''}
      let req = {
        channelIds: [],
        current: 1,
        orderNum: outerId ? outerId : this.orderDetailData.outerOrderId,
        orderStatus: -1,
        size: 10
      }
      if (partnerInfo.homeChannelId && req.channelIds.includes(partnerInfo.homeChannelId)) {
        req.channelIds.push(partnerInfo.homeChannelId)
      }
      if (partnerInfo.overseaChannelId && req.channelIds.includes(partnerInfo.overseaChannelId)) {
        req.channelIds.push(partnerInfo.overseaChannelId)
      }
      const {data: result} = await this.$http.post('/b2b/searchB2BOrder', req, {headers})
      if (result.code !== 200) return this.closeInterval()
      if (!result.data || !result.data.orderList || !result.data.orderList.length) return
      this.orderDetailData = result.data.orderList[0]
      if (this.orderDetailData.orderStatus === 3 || this.orderDetailData.orderStatus === 15 && this.orderStatusInterval) {
        this.closeInterval()
      }
    },
    async onSearch () {
      let req = {
        channelId: this.orderDetailData.channelId,
        sHotelId: this.orderDetailData.hotelId
      }
      const {data: result} = await this.$http.get('/b2b/getSHotelByChannelAndId', {params: req})
      // this.hotelInfo = {...result.data}
      let customer = this.getExtensionsValue(this.orderDetailData.extensions, 'customer')
      let address = this.getExtensionsValue(this.orderDetailData.extensions, 'address')
      let phone = this.getExtensionsValue(this.orderDetailData.extensions, 'hotelPhone')
      this.hotelInfo = result.data
      this.hotelInfo.customer = customer || ''
      this.hotelInfo.address = address || result.data.address
      this.hotelInfo.phone = phone || result.data.phone
    },
    getExtensionsValue (extensions, key) {
      if (!extensions) return ''
      try {
        let info = JSON.parse(extensions)
        return info[key]
      } catch (e) {
        return ''
      }
    },
    searchOrder () {
      let req = {
        orderId: this.orderDetailData.orderId
      }
      let vm = this
      vm.$http.get('/b2b/searchB2BOrderById', {params: req}).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.orderDetailData = result.data
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
    },
    cancelOrder () {
      let vm = this
      vm.$confirm(this.$t('center.confirm_cancel'), this.$t('header.Reminder'), {
        confirmButtonText: this.$t('header.confirm'),
        cancelButtonText: this.$t('header.cancel'),
        type: 'warning'
      }).then(() => {
        let loading = vm.$loading({
          // lock: true,
          text: 'loading.....',
          spinner: 'el-icon-loading',
          background: vm.$finalData.LoadingBgColorAll
        })
        let req = {
          accessToken: this.partnerInfo.token
        }
        vm.$http.get(`/mini/cancel2?outerOrderId=${vm.orderDetailData.outerOrderId}`, {headers: req}).then(resp => {
          let result = resp.data
          if (result.code != 200) {
            vm.$message.warning(this.$t('center.cancel_failed'))
          } else {
            vm.$message.success(this.$t('center.commit_cancel'))
          }
        }).catch(resp => {
          vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
        }).finally(() => {
          loading.close()
          vm.searchOrder()
        })
      }).catch(() => {
      })
    },
    canCancelTime (cancellationPolicy) {
      if (cancellationPolicy) {
        let cancelTime = new Date(cancellationPolicy).getTime()
        let nowTime = new Date().getTime()
        return cancelTime > nowTime
      }
      return false
    },
    canCancelStatus () {
      return this.confirmStatusList.includes(this.orderDetailData.orderStatus)
    },
    getStatusName (val) {
      if (!val) {
        return this.$t('center.Created')
      }
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(val) != -1) {
          return item.name
        }
      }
      return ''
    },
    getStatusItem (val) {
      if (!val) {
        return {}
      }
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(val) != -1) {
          return item
        }
      }
      return {}
    },
    formateExtensions (ext) {
      if (ext) {
        try {
          return JSON.parse(ext)
        } catch (e) {
          return null
        }
      }
    },
    toHotelDetail () {
      if (!this.orderDetailData.hotelId) return
      let nowDate = new Date()
      let checkIn = this.$common.formatterDate(nowDate)
      let checkOut = this.$common.formatterDate(new Date(nowDate.getTime() + 86400000))
      let hotelDetailSearchForm = JSON.parse(localStorage.getItem('hotelDetailSearchForm'))
      if (hotelDetailSearchForm) {
        hotelDetailSearchForm.checkIn = checkIn
        hotelDetailSearchForm.checkOut = checkOut
        hotelDetailSearchForm.checkDates = [checkIn, checkOut]
        hotelDetailSearchForm.hotelId = this.orderDetailData.outHotelId
        localStorage.setItem('hotelDetailSearchForm', JSON.stringify(hotelDetailSearchForm))
        window.open('HotelDetail', '_blank')
      }
    },
    async getWorkOrderTypes () {
      const {data: result} = await this.$http.get('/work_order_api/2.0/workOrderTypes')
      if (result.resultCode != 0) return this.$message.error('网络错误，请稍后再试')
      this.workOrderTypes = result.workOrderTypes
    },
    getWorkOrderTypeName (typeId, sub) {
      if (sub) {
        let typeInfo = this.workOrderTypes.filter(item => item.typeId == typeId)[0]
        return typeInfo ? typeInfo.typeName : '未知'
      }
      return typeId == 1 ? '未到店' : typeId == 2 ? '已到店' : '已离店'
    },
    // 0/null: 待处理   1：处理中  2：已完成
    getWorkOrderStatusName (status) {
      if (!status) {
        return '待处理'
      }
      return status == 1 ? '处理中' : '已完成'
    },
    getStatusColor (status) {
      if (!status) {
        return '#909399'
      }
      return status == 1 ? '#f6c659' : '#67c23a'
    },
    getOperator (e) {
      if (e.operatorType) {
        return `${e.operator}(科坦客服)\t`
      } else {
        return e.operator + '\t'
      }
    },
    getImags (imgJson) {
      if (!imgJson) {
        return []
      }
      try {
        return JSON.parse(imgJson)
      } catch (e) {
        return []
      }
    },
    showImg (imgUrl) {
      this.selImg = [imgUrl]
      this.showBigImg = true
    },
    onClose () {
      this.showBigImg = false
    },
    async searchOrderItem () {
      const {data: result} = await this.$http.get(`b2b/searchOrderItem?sOrderId=${this.orderDetailData.orderId}`, {headers: {accessToken: this.partnerInfo.token}})
      if (result.code !== 200) return
      this.dailyPrice = []
      if (result.data && result.data.dailyPrice) {
        this.dailyPriceMap = JSON.parse(result.data.dailyPrice)
        this.dailyPrice = this.convertToStructuredArray(JSON.parse(result.data.dailyPrice))
      }
    },
    convertToStructuredArray (dataObj, maxColumns = 7) {
      // 提取并排序日期键
      const sortedDates = Object.keys(dataObj).sort((a, b) => new Date(a) - new Date(b))
      // 转换为包含date和value字段的对象数组
      const structuredData = sortedDates.map(date => ({
        date: date,
        value: dataObj[date]
      }))
      // 分割为n行maxColumns列的二维数组
      const result = []
      for (let i = 0; i < structuredData.length; i += maxColumns) {
        result.push(structuredData.slice(i, i + maxColumns))
      }
      return result
    },
    async searchWorkOrders (move) {
      const {data: result} = await this.$http.get(`/mini/searchWorkOrdersInfo?outerOrderId=${this.orderDetailData.outerOrderId}`, {headers: {accessToken: this.partnerInfo.token}})
      if (result.code != 200) return this.$message.error(result.message)
      this.workOrderList = result.data
      this.workOrderList.sort(this.sortWorkOrder)
      this.workOrderList.forEach((item) => {
        // 状态为已完成或为受理的不显示催单按钮
        if (!item.workOrderItem.status || (item.workOrderItem.status == 0 || item.workOrderItem.status == 2)) {
          this.$set(item.workOrderItem, 'showUrgeBtn', false)
        } else {
          let showUrgeBtn = item.details.some(i => i.handleContent == '催单')
          this.$set(item.workOrderItem, 'showUrgeBtn', !showUrgeBtn)
        }
        // 展开状态
        if (this.expandMap[item.workOrderItem.workOrderId] != undefined) {
          this.$set(this.expandMap, item.workOrderItem.workOrderId, this.expandMap[item.workOrderItem.workOrderId])
        } else {
          this.$set(this.expandMap, item.workOrderItem.workOrderId, true)
        }
        // 是否要定位到当前工单
        if (this.orderDetailData.newWorkOrderId && move) {
          if (this.orderDetailData.newWorkOrderId == item.workOrderItem.workOrderId) {
            this.$nextTick(() => {
              const currBox = this.$refs[item.workOrderItem.workOrderId]
              if (currBox) {
                currBox[0].scrollIntoView({'behavior': 'smooth'})
              }
            })
          } else {
            this.$set(this.expandMap, item.workOrderItem.workOrderId, false)
          }
        }
        // 初始化每条工单的消息列表
        if (this.msgList[item.workOrderItem.workOrderId]) {
          this.$set(this.msgList, item.workOrderItem.workOrderId, {
            msg: this.msgList[item.workOrderItem.workOrderId].msg,
            fileList: this.msgList[item.workOrderItem.workOrderId].fileList
          })
        } else {
          this.$set(this.msgList, item.workOrderItem.workOrderId, {
            msg: '',
            fileList: []
          })
        }
      })
    },
    sortWorkOrder (a, b) {
      const statusA = a.workOrderItem.status || 0
      const statusB = b.workOrderItem.status || 0
      if (statusA === 1 && statusB !== 1) {
        return -1 // a的status为1，排在b前面
      } else if (statusA !== 1 && statusB === 1) {
        return 1 // b的status为1，排在a前面
      } else if (statusA === 2 && statusB !== 2) {
        return 1 // a的status为2，排在b后面
      } else if (statusA !== 2 && statusB === 2) {
        return -1 // b的status为2，排在a后面
      } else {
        return new Date(b.workOrderItem.createTime) - new Date(a.workOrderItem.createTime)
      }
    },
    closeDialog (isCommit) {
      this.showAddWorkOrderDialog = false
      if (isCommit == true) {
        this.searchWorkOrders()
      }
    },
    handleExceed () {
      this.$message.warning('仅允许上传9张图片')
    },
    onFileChange (file, fileList, workOrderId) {
      this.msgList[workOrderId].fileList = fileList
    },
    onFileRemove (file, fileList, workOrderId) {
      this.msgList[workOrderId].fileList = fileList
    },
    async urgeWorkOrder (row) {
      let reqForm = {
        workOrderId: row.workOrderItem.workOrderId,
        operator: ''
      }
      let name = this.partnerInfo.personType == 1 ? this.partnerInfo.name : this.partnerInfo.accountName
      reqForm.operator = `${name}(${this.partnerInfo.companyName})`
      const {data: result} = await this.$http.post('/work_order_api/2.0/urgeWorkOrder', reqForm)
      if (result.resultCode != 0) return this.$message.error(result.detailError)
      this.$message.success('催单成功，我们将尽快处理')
      this.searchWorkOrders()
    },
    async sendMsg (workOrderId, e) {
      if (e.ctrlKey && e.keyCode == 13) {
        this.msgList[workOrderId].msg += '\n'
        return
      }
      if (!this.msgList[workOrderId].msg || !this.msgList[workOrderId].msg.trim()) {
        this.$message.warning('请输入内容')
        this.msgList[workOrderId].msg = ''
        return
      }
      let msgForm = {
        workOrderId,
        remark: this.msgList[workOrderId].msg.trim(),
        operator: '',
        attachments: []
      }
      let name = this.partnerInfo.personType == 1 ? this.partnerInfo.name : this.partnerInfo.accountName
      msgForm.operator = `${name}(${this.partnerInfo.companyName})`
      if (this.msgList[workOrderId].fileList.length) {
        let imgUrl = await this.uploadImage(workOrderId)
        if (imgUrl) {
          msgForm.attachments = imgUrl
        }
      }
      const {data: result} = await this.$http.post('/work_order_api/2.0/updateWorkOrder', msgForm)
      if (result.resultCode !== 0) return this.$message.error(result.resultMessage)
      await this.searchWorkOrders()
      this.msgList[workOrderId].msg = ''
      this.msgList[workOrderId].fileList = []
      this.moveToTop(workOrderId)
    },
    async uploadImage (workOrderId) {
      let formData = new FormData()
      formData.append('outerOrderId', this.orderDetailData.outerOrderId)
      this.msgList[workOrderId].fileList.forEach(file => {
        formData.append('file', file.raw)
      })
      const {data: result} = await this.$http.post('/mini/uploadImage', formData, {headers: {accessToken: this.partnerInfo.token}})
      if (result.code != 200) return this.$message.error(result.message)
      return result.data
    },
    moveToTop (workOrderId) {
      let el = this.$refs['d' + workOrderId]
      if (el) {
        this.$nextTick(() => {
          el[0].scrollTop = 0
        })
      }
    },
    handleMessage (data) {
      // 受理工单/结束工单
      if (data.type == '/acceptance' || data.type == '/finish') {
        if (this.orderDetailData.outerOrderId == data.outerId) {
          this.searchWorkOrders()
        }
      } else if (data.type == 'urgentWorkOrder') {
        if (this.workOrderList.some(i => i.workOrderItem.workOrderId == data.workOrderId)) {
          this.searchWorkOrders()
        }
      } else if (data.type == 'newWorkOrder') {
        if (this.orderDetailData.outerOrderId == data.workOrder.outerOrderId) {
          this.searchWorkOrders()
        }
      } else if (data.type == 'updateWorkOrder') {
        if (this.orderDetailData.outerOrderId == data.outerId) {
          this.searchWorkOrders()
          this.moveToTop(data.data)
        }
      }
    },
    toHotelConfirmOrder () {
      let url = '/HotelConfirmOrder?params=' + window.btoa(encodeURIComponent(JSON.stringify(this.orderDetailData)))
      window.open(url, '_blank')
    },
    async searchExternalOrderImages () {
      let req = {
        accessToken: this.partnerInfo.token
      }
      const {data: result} = await this.$http.get(`/mini/searchExternalOrderImages?outerOrderId=${this.orderDetailData.outerOrderId}`, {headers: req})
      if (result.code !== 200) return this.imgs = []
      this.imgs = result.data
    },
    getHotelName (regionId) {
      if (!this.orderDetailData.hotelName) return ''
      let hotelNameArr = this.orderDetailData.hotelName.split('-')
      if (hotelNameArr.length === 2) {
        return regionId === 1 ? hotelNameArr[0] : hotelNameArr[1]
      }
      return this.orderDetailData.hotelName
    },
    async showRoomDetail () {
      let req = {
        accessToken: this.partnerInfo.token
      }
      const {data: result} = await this.$http.get(`/mini/getRoomInfoByOrderId?orderId=${this.orderDetailData.orderId}&sHotelId=${this.orderDetailData.hotelId}`, {headers: req})
      if (result.code !== 200) return
      if (!result.data.allImages) return
      let roomInfo = result.data.roomInfos ? result.data.roomInfos[0] : null
      result.data.allImages.forEach(item => {
        this.$set(item, 'key', this.getUUID())
      })
      let imgs = result.data.allImages.filter(item => item.roomId === roomInfo.roomId)
      if (roomInfo === null) return
      this.showImgDialog(imgs, roomInfo.images ? roomInfo.images[0] : '', 2, roomInfo)
    },
    showImgDialog (imgs, url, type, room) {
      if (type === 1) {
        if (!imgs || !imgs.length || !url) return
        let index = imgs.findIndex(item => item.imageUrl === url)
        this.$refs['hotelImgRef'].init(imgs, index, type)
      } else {
        room.regionId = this.$commonUtil.getRegionBySHotelId(this.orderDetailData.hotelId)
        if (!imgs || !imgs.length || !url) {
          this.$refs['hotelImgRef'].init([], -1, type, room)
        } else {
          let index = imgs.findIndex(item => item.imageUrl === url)
          this.$refs['hotelImgRef'].init(imgs, index, type, room)
        }
      }
    },
    getUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    changeChlOrderNum () {
      this.newChlOrderNum = ''
      this.showChangeChlOrderNumDialog = true
    },
    async submitChange() {
      if (!this.newChlOrderNum) return this.$message.warning('请输入订单号')
      this.changeBtnLoading = true
      let req = {
        channelId: this.orderDetailData.channelId,
        outerId: this.orderDetailData.outerOrderId,
        newChlOrderNum: this.newChlOrderNum
      }
      let header = {
        accessToken: this.partnerInfo.token
      }
      const {data: result} = await this.$http.post(`/mini/updateChlOrderNum`, req, {headers: header})
      this.changeBtnLoading = false
      if (result.code !== 200) return this.$message.error(result.message)
      await this.setOrderStatus()
      this.$message.success('修改成功')
      this.showChangeChlOrderNumDialog = false
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background-color: #f5f7fa;
}

.order_datail_box {
  display: grid;
  grid-template-columns: 1fr 1180px 1fr;

  .order_info_box,
  .hotel_info_box {
    padding: 15px;
    background-color: #fff;
    margin-bottom: 30px;

    display: grid;
    grid-template-columns: repeat(3, auto);

    .order_num {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      background-color: #edeff8;
    }

    .order_info_item {
      height: 45px;
      line-height: 45px;
      font-family: '苹方';
      padding: 0 10px;
      border: 1px solid #e8ebef;
      border-collapse: collapse;
      margin-top: -1px;
      margin-left: -1px;
    }

    .confirm_btn_box {
      grid-column-start: 3;
      grid-column-end: 4;
      grid-row-start: 2;
      grid-row-end: 4;
      border-right: 1px solid #e8ebef;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .order_num,
    .order_status {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    .img_box {
      display: flex;
      column-gap: 15px;
      grid-column-start: 1;
      grid-column-end: 4;
      height: 115px;
      padding: 15px 10px;

      .img__content {
        display: flex;
        column-gap: 15px;
      }
    }
  }

  .attention_item_box {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 30px;

    .attention_item {
      display: grid;
      grid-template-columns: 100px 50%;
      grid-template-rows: repeat(3, auto);
      grid-gap: 20px;
      line-height: 20px;

      .attention_item_title {
        color: #a3a3a3;
      }
    }
  }

  .box_title {
    height: 45px;
    line-height: 45px;
    background-color: #edeff8;
    padding: 0 10px;
    font-size: 14px;
    font-weight: bold;
    font-family: '苹方';
    border-bottom: 1px solid #e8ebef;
    border-radius: 8px 8px 0 0;
  }

  .work_order_content {
    font-family: '苹方';
    background-color: #fff;
    padding: 15px;

    .item_box {
      border: 1px solid #e8ebef;
      border-top: none;
      padding: 15px;

      .work_order_item {
        border: 1px solid #e8ebef;

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        .item_header {
          display: flex;
          padding: 15px 10px;
          align-items: center;
          position: relative;
          column-gap: 25px;

          &::before {
            content: "";
            display: block;
            width: 98%;
            height: 1px;
            background: #e8ebef;
            position: absolute;
            bottom: 0;
            left: .5%;
          }
        }

        .status {
          padding: 3px 10px;
          color: #fff;
          border-radius: 50px;
        }

        .item_content {
          transition: max-height .2s ease-in-out;

          .item_content_title {
            font-size: 14px;
            font-weight: bold;
            font-family: '苹方';
            position: relative;
            padding-bottom: 10px;
            margin-bottom: 10px;

            &::before {
              content: "";
              display: block;
              width: 40px;
              height: 2px;
              position: absolute;
              background-color: #1e50f0;
              bottom: 0;
              left: 8px;
            }
          }

          .detail {
            display: flex;
            padding-top: 10px;
            column-gap: 20px;
            height: 350px;
            overflow: auto;
            scroll-behavior: smooth;

            .msg_deatil {
              border-bottom: 1px solid #e8ebef;
              padding-bottom: 8px;
              padding-right: 20px;
              font-size: 13px;
              font-family: '苹方';
              line-height: 20px;
            }
          }

          .reply_box {
            margin-top: 20px;
            flex-basis: 100%;
            position: relative;

            .send_btn {
              position: absolute;
              bottom: 4px;
              right: 6px;
            }
          }

          /deep/ .el-textarea .el-input__count {
            right: 80px;
            bottom: 12px;
          }

          /deep/ .el-upload-list__item-name {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

          /deep/ .el-upload-list__item {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

        }

        .item_content.close {
          max-height: 0;
          overflow: hidden;
        }

        .item_content.open {
          padding: 15px;
          min-height: 560px;
          overflow: hidden;
        }
      }
    }


  }

  /deep/ .el-button--primary:hover {
    background-color: #1e50f0;
  }

  /deep/ .el-button--primary.is-disabled:hover {
    background-color: #C0C4CC;
  }

}

/deep/ .el-dialog__header {
  background-color: #fff;
  padding: 10px 20px;
}

/deep/ .el-dialog__title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

.price_info {
  //padding: 15px;
  //background-color: #fff;
  //margin-bottom: 30px;

  .price_title {
    font-size: 14px;
    font-weight: bold;
    background-color: #edeff8;
    height: 45px;
    line-height: 45px;
    font-family: '苹方';
    padding: 0 10px;
  }

  .content {
    display: flex;
    flex-wrap: wrap;
  }

  .item_content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }


}

.order_box_new {
  display: flex;
  column-gap: 16px;

  .main_box {
    width: 718px;

    .order_status_box, .order_basic_box {
      margin-bottom: 16px;
    }

    .order_basic_box {
      .info_item {
        display: flex;
        column-gap: 12px;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 16px;

        .title {
          width: 88px;
          text-align: right;
        }

        .info {
          font-weight: normal;
          color: #374151;
          font-size: 13px;
          line-height: 20px;
        }

        .a_text {
          color: #007AFF;
          font-weight: 400;
          cursor: pointer;
          user-select: none;
          word-break: keep-all;
        }
      }
    }

    .work_order_content {
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      background-color: #fff;
      padding: 15px;

      .item_box {
        border: 1px solid #e8ebef;
        border-top: none;
        padding: 15px;
        border-radius: 0 0 8px 8px;

        .work_order_item {
          border: 1px solid #e8ebef;

          &:not(:last-child) {
            margin-bottom: 15px;
          }

          .item_header {
            display: flex;
            padding: 15px 10px;
            align-items: center;
            position: relative;
            column-gap: 25px;

            &::before {
              content: "";
              display: block;
              width: 98%;
              height: 1px;
              background: #e8ebef;
              position: absolute;
              bottom: 0;
              left: .5%;
            }
          }

          .status {
            padding: 3px 10px;
            color: #fff;
            border-radius: 50px;
          }

          .item_content {
            transition: max-height .2s ease-in-out;

            .item_content_title {
              font-size: 14px;
              font-weight: bold;
              position: relative;
              padding-bottom: 10px;
              margin-bottom: 10px;

              &::before {
                content: "";
                display: block;
                width: 40px;
                height: 2px;
                position: absolute;
                background-color: #1e50f0;
                bottom: 0;
                left: 8px;
              }
            }

            .detail {
              display: flex;
              padding-top: 10px;
              column-gap: 20px;
              height: 350px;
              overflow: auto;
              scroll-behavior: smooth;

              .msg_deatil {
                border-bottom: 1px solid #e8ebef;
                padding-bottom: 8px;
                padding-right: 20px;
                font-size: 13px;
                font-family: '苹方';
                line-height: 20px;
              }
            }

            .reply_box {
              margin-top: 20px;
              flex-basis: 100%;
              position: relative;

              .send_btn {
                position: absolute;
                bottom: 4px;
                right: 6px;
              }
            }

            /deep/ .el-textarea .el-input__count {
              right: 80px;
              bottom: 12px;
            }

            /deep/ .el-upload-list__item-name {
              transition: none !important;
              -webkit-transition: nonne !important;
            }

            /deep/ .el-upload-list__item {
              transition: none !important;
              -webkit-transition: nonne !important;
            }

          }

          .item_content.close {
            max-height: 0;
            overflow: hidden;
          }

          .item_content.open {
            padding: 15px;
            min-height: 560px;
            overflow: hidden;
          }
        }
      }


    }

    /deep/ .el-button--primary:hover {
      background-color: #1e50f0;
    }

    /deep/ .el-button--primary.is-disabled:hover {
      background-color: #C0C4CC;
    }
  }

  .right_box {
    width: 380px;

    .hotel_info_box_new {
      margin-bottom: 16px;
    }

    .hotel_img {
      width: 100%;
      height: 160px;
      margin-top: 15px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }

    .hotel_name {
      margin-top: 15px;
      display: flex;
      column-gap: 8px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}

.basic_box {
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.notice_item {
  background-color: #f9fafb;
  padding: 20px 40px 20px 20px;
  border-radius: 8px;
  margin-top: 15px;

  .notice_title {
    font-size: 14px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
}

.price_box {
  .price_info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #575f6d;
    margin-bottom: 16px;
  }

  .total_box {
    padding-top: 16px;
    border-top: 1px solid #f7f8f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;

    .price {
      font-size: 20px;
      font-weight: bolder;
      color: #1e50f0;
    }
  }
}

.room_detail {
  & /deep/ .el-dialog {
    border-radius: 7px;
  }

  & /deep/ .el-dialog__header {
    height: 0;
    padding: 0;
  }

  & /deep/ .el-dialog__body {
    padding: 35px;
  }
}

& /deep/ .el-dialog.order_dialog {
  border-radius: 8px;

  .el-dialog__header {
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/OrderDetail.vue